import React from "react";
import { Bar } from 'react-chartjs-2';

const BarChart = (props) => {
  const { title, data, options } = props;
  if(data && options) {
    return (
      <>
        {title ? <h3 className="text-center">{title}</h3> : null}
        <Bar
          options={options}
          data={data}
        />
      </>
    )
  } else {
    return (
      <>
      </>
    )
  }
};

export default BarChart;